import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { BoxAvailability } from '../../../../../@posturinn/client-react';
import * as StyledDeliveryOptionsList from '../../deliveryOption/deliveryOptionsList/deliveryOptionsList.styles';
import * as StyledModals from '../../myShipmentsModals.styles';
import * as StyledDropOff from './dropOffList.styles';

interface Props {
	locations: any;
	selectedLocation: string;
	setSelectedLocation: any;
	search: any;
}

const DropOffList: FC<Props> = ({ locations, selectedLocation, setSelectedLocation, search }) => {
	const { t } = useTranslation('myShipments');

	return (
		<StyledDeliveryOptionsList.Wrapper>
			{locations?.map(
				location =>
					search(location) && (
						<div key={location.id} id={location.id}>
							<StyledModals.CardWrapper
								highlight={location.id === selectedLocation}
								grayHighlight={
									location.id === selectedLocation && location.status === BoxAvailability.Medium
								}
								primaryHighlight={
									location.id === selectedLocation &&
									[BoxAvailability.Low, BoxAvailability.None].includes(location.status)
								}>
								<StyledModals.CardLink
									highlight={location.id === selectedLocation}
									onClick={() =>
										setSelectedLocation(location.id, location.latitude, location.longitude, false)
								}>
									<StyledModals.CardHeading>
										<div>{location.name}</div>
										<div>{location.address.postalCode}</div>
									</StyledModals.CardHeading>
									<StyledModals.CardSubHeading>
										{location.address.street1}
									</StyledModals.CardSubHeading>
									<div>{location.statusMessage}</div>
									<StyledDropOff.StatusWrapper status={location.status}>
										{location.status === BoxAvailability.High ? (
											<FaCheckCircle />
										) : (
											<FaExclamationTriangle />
										)}
										{location.status === BoxAvailability.High && t('dropOffStatus.high')}
										{location.status === BoxAvailability.Medium && t('dropOffStatus.medium')}
										{location.status === BoxAvailability.Low && t('dropOffStatus.low')}
										{location.status === BoxAvailability.None && t('dropOffStatus.none')}
									</StyledDropOff.StatusWrapper>
								</StyledModals.CardLink>
							</StyledModals.CardWrapper>
						</div>
					)
			)}
		</StyledDeliveryOptionsList.Wrapper>
	);
};

export default DropOffList;
